import { render, staticRenderFns } from "./OrderChangeCommon.vue?vue&type=template&id=05fb3420&scoped=true"
import script from "./OrderChangeCommon.vue?vue&type=script&lang=js"
export * from "./OrderChangeCommon.vue?vue&type=script&lang=js"
import style0 from "./OrderChangeCommon.vue?vue&type=style&index=0&id=05fb3420&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05fb3420",
  null
  
)

export default component.exports